import type { LinkProps } from 'react-router-dom'

import type { IconRegistry, Size } from '@percent/lemonade'

export type LinkButtonVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'approve'
  | 'reject'

export type LinkButtonSize = 'mini' | 'small' | 'medium' | 'large'

export type LinkButtonShape = 'default' | 'oval'

export interface LinkButtonProps extends LinkProps {
  variant?: LinkButtonVariant
  size?: LinkButtonSize
  shape?: LinkButtonShape
  stretch?: boolean
  disabled?: boolean
  startIcon?: keyof typeof IconRegistry
  startIconSize?: Size
  endIcon?: keyof typeof IconRegistry
  endIconSize?: Size
  'data-testid'?: string
}
